import { useEffect, useState } from "react";
import { getListTypeEntriesByExternalReferenceCode } from "../services/course";

const useFetchPersonas = () => {
  const [personas, setPersonas] = useState([]);

  useEffect(() => {
    const fetchPersonasData = async () => {
      try {
        const response = await getListTypeEntriesByExternalReferenceCode("T4T14_PERSONAS");

        if (response && Array.isArray(response.items)) {

          setPersonas(response.items);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchPersonasData();
  }, [setPersonas]);

  return (
    {personas}
  )
}
export default useFetchPersonas;